<template>
  <div class="ml-2 mb-2">
    <v-chip
      v-if="filterValues.type && typeof filterValues.type === 'number'"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      {{ findTypeName(filterValues.type) }}
      <v-icon right @click="removeFromFilter('type', '')"> mdi-close </v-icon>
    </v-chip>
    <template v-if="filterValues.type && typeof filterValues.type === 'object'">
      <v-chip
        v-for="(chipItem, index) in filterValues.type"
        :key="'type' + index"
        class="mr-2 mt-2 custom-filter-chip"
        color="primary-20"
        text-color="secondary-btn"
        :label="false"
      >
        {{ findTypeArrayName(chipItem) }}
        <v-icon right @click="removeFromFilter('type', chipItem, true)">
          mdi-close
        </v-icon>
      </v-chip>
    </template>
    <v-chip
      v-if="filterValues.qInclude"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      {{ findQIncludeText(filterValues.qInclude) }}
      <v-icon right @click="removeFromFilter('qInclude', '')">
        mdi-close
      </v-icon>
    </v-chip>
    <v-chip
      v-for="(chipItem, index) in filterValues.status"
      :key="'status' + index"
      class="mr-2 mt-2 custom-filter-chip capitalize"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      {{ findStatusText(chipItem) }}
      <v-icon right @click="removeFromFilter('status', chipItem)">
        mdi-close
      </v-icon>
    </v-chip>
    <v-chip
      v-if="filterValues.success !== '' && filterValues.success !== undefined"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      {{ findSuccessName(filterValues.success) }}
      <v-icon right @click="removeFromFilter('success', '')">
        mdi-close
      </v-icon>
    </v-chip>
    <v-chip
      v-for="(chipItem, index) in filterValues['page.status']"
      :key="'page.status' + index"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      {{ findStatusText(chipItem) }}
      <v-icon right @click="removeFromFilter('page.status', chipItem)">
        mdi-close
      </v-icon>
    </v-chip>
    <v-chip
      v-for="(chipItem, index) in filterValues['number']"
      :key="'number' + index"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      {{ findNumberFilterText(chipItem) }}
      <v-icon right @click="removeFromFilter('number', chipItem)">
        mdi-close
      </v-icon>
    </v-chip>
    <span v-if="!hideDomainFilter">
      <v-chip
        v-for="(chipItem, index) in filterValues.domain"
        :key="'domain' + index"
        class="mr-2 mt-2 custom-filter-chip"
        color="primary-20"
        text-color="secondary-btn"
        :label="false"
      >
        {{ domainFilterNameByValue(chipItem) }}
        <v-icon right @click="removeFromFilter('domain', chipItem)">
          mdi-close
        </v-icon>
      </v-chip>
      <v-chip
        v-for="(chipItem, index) in filterValues['page.domain']"
        :key="'domain' + index"
        class="mr-2 mt-2 custom-filter-chip"
        color="primary-20"
        text-color="secondary-btn"
        :label="false"
      >
        {{ domainFilterNameByValue(chipItem) }}
        <v-icon right @click="removeFromFilter('page.domain', chipItem)">
          mdi-close
        </v-icon>
      </v-chip>
    </span>
    <v-chip
      v-for="(chipItem, index) in filterValues.label"
      :key="'label' + index"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      {{ labelFilterNameByValue(chipItem) }}
      <v-icon right @click="removeFromFilter('label', chipItem)">
        mdi-close
      </v-icon>
    </v-chip>
    <v-chip
      v-for="(chipItem, index) in filterValues['owner']"
      :key="'owner' + index"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      {{ ownerFilterNameByValue(chipItem) }}
      <v-icon right @click="removeFromFilter('owner', chipItem)">
        mdi-close
      </v-icon>
    </v-chip>
    <v-chip
      v-for="(chipItem, index) in filterValues['goal']"
      :key="'goal' + index"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      {{ goalFilterNameByValue(chipItem) }}
      <v-icon right @click="removeFromFilter('goal', chipItem)">
        mdi-close
      </v-icon>
    </v-chip>
    <v-chip
      v-if="filterValues['exists[label]'] === false"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
    >
      No label
      <v-icon
        right
        @click="
          removeFromFilter('exists[label]', filterValues['exists[label]'])
        "
      >
        mdi-close
      </v-icon>
    </v-chip>
    <v-chip
      v-for="(chipItem, index) in filterValues.number"
      :key="'number' + index"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      {{ findNumberText(chipItem) }}
      <v-icon right @click="removeFromFilter('number', chipItem)">
        mdi-close
      </v-icon>
    </v-chip>
    <v-chip
      v-if="filterValues['exists[gtmId]']"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      GTM - {{ findGtmText(filterValues["exists[gtmId]"]) }}
      <v-icon
        right
        @click="
          removeFromFilter('exists[gtmId]', filterValues['exists[gtmId]'])
        "
      >
        mdi-close
      </v-icon>
    </v-chip>
    <v-chip
      v-if="filterValues['exists[journayaScript]']"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      JOURNAYA - {{ findGtmText(filterValues["exists[journayaScript]"]) }}
      <v-icon
        right
        @click="
          removeFromFilter(
            'exists[journayaScript]',
            filterValues['exists[journayaScript]']
          )
        "
      >
        mdi-close
      </v-icon>
    </v-chip>
    <v-chip
      v-if="filterValues['exists[leadspediaId]']"
      class="mr-2 mt-2 custom-filter-chip"
      color="primary-20"
      text-color="secondary-btn"
      :label="false"
    >
      LEADSPEDIA - {{ findGtmText(filterValues["exists[leadspediaId]"]) }}
      <v-icon
        right
        @click="
          removeFromFilter(
            'exists[leadspediaId]',
            filterValues['exists[leadspediaId]']
          )
        "
      >
        mdi-close
      </v-icon>
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "FormFilterValuesList",
  props: {
    filterValues: {
      type: Object,
      default: () => {},
    },
    domainsList: {
      type: Array,
      default: () => [],
    },
    labelsList: {
      type: Array,
      default: () => [],
    },
    goalsList: {
      type: Array,
      default: () => [],
    },
    ownersList: {
      type: Array,
      default: () => [],
    },
    hideDomainFilter: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    removeFromFilter(source, value, array = false) {
      const filterValues = { ...this.filterValues };
      if (
        [
          "exists[label]",
          "exists[gtmId]",
          "exists[journayaScript]",
          "exists[leadspediaId]",
        ].includes(source)
      ) {
        filterValues[source] = undefined;
      } else if (
        !array &&
        (source === "type" || source === "qInclude" || source === "success")
      ) {
        filterValues[source] = value;
      } else {
        filterValues[source] = filterValues[source].filter((item) => {
          return item !== value;
        });
      }

      this.$emit("filter-removed", filterValues);
    },
    findTypeName(typeValue) {
      return this.$admin.constants.PAGE_TYPES.find(
        (type) => type.value === typeValue
      )?.text;
    },
    findTypeArrayName(typeValue) {
      return this.$admin.constants.FORM_TYPE_FILTERS.find(
        (type) => type.value == typeValue
      )?.text;
    },
    findSuccessName(successValue) {
      return this.$admin.constants.SUCCESS_FILTERS.find(
        (item) => item.value === successValue
      )?.text;
    },
    findQIncludeText(qIncludeValue) {
      return this.$admin.constants.ADVANCED_CONTENT_SEARCH.find(
        (qInclude) => qInclude.value === qIncludeValue
      )?.text;
    },
    findStatusText(statusValue) {
      return (
        this.$admin.constants.PAGE_STATUSES.find(
          (status) => status.value === statusValue
        )?.text || statusValue
      );
    },
    findGtmText(statusValue) {
      return this.$admin.constants.GTM_FILTERS.find(
        (status) => status.value === statusValue
      )?.text;
    },
    findNumberFilterText(statusValue) {
      return this.$admin.constants.RINGBA_FILTERS.find((item) =>
        item.options.find((status) => {
          if (status.value === statusValue) {
            return true;
          }
        })
      )?.options.find((status) => status.value === statusValue)?.text;
    },
    domainFilterNameByValue(value) {
      return this.domainsList.find((domain) => domain.id === value)?.text;
    },
    labelFilterNameByValue(value) {
      return this.labelsList.find((label) => label.id === value)?.name;
    },
    goalFilterNameByValue(value) {
      return this.goalsList.find((goal) => goal.id === value)?.name;
    },
    ownerFilterNameByValue(value) {
      return this.ownersList.find((owner) => owner.id === value)?.firstName;
    },
  },
};
</script>

<style></style>
